import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

export const PROVIDER_MIGRATION_STEPS = [
  { key: "connect", label: "Connection", to: "/reconciliation/provider-migration/connect" },
  { key: "discovery", label: "Discovery", to: "/reconciliation/provider-migration/discovery" },
  { key: "import-review", label: "Import review", to: "/reconciliation/provider-migration/import-review" },
  { key: "export", label: "Export evidence", to: "/evidence/provider-migration/export" },
  { key: "disposition", label: "Disposition", to: "/reconciliation/provider-migration/disposition" },
] as const;

export type ProviderMigrationStep = (typeof PROVIDER_MIGRATION_STEPS)[number]["key"];

/** Route-level step bar for the read-only provider-migration journey (same anatomy as HotWalletTabs). */
export function ProviderMigrationNav({ active }: { active: ProviderMigrationStep }) {
  return (
    <nav aria-label="Provider migration steps" className="mb-5 flex overflow-x-auto border-b border-line">
      {PROVIDER_MIGRATION_STEPS.map((step, index) => (
        <NavLink
          key={step.key}
          to={step.to}
          aria-current={active === step.key ? "page" : undefined}
          className={({ isActive }) =>
            cn(
              "min-h-9 shrink-0 whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-semibold transition-colors",
              isActive ? "border-primary text-primary" : "border-transparent text-muted hover:text-ink",
            )
          }
        >
          {index + 1}. {step.label}
        </NavLink>
      ))}
    </nav>
  );
}
